import React from 'react'
import ShortHeader from '../Header/ShortHeader'
import AssistedReproductionSection from '../AssistedReproduction'
import SpainHeaderComp from '../Header/SpainHeaderComp'
import Section from '../Section'
import GestlifeStickyLayout from '../SpainUsText/SpainUsText'
import FivSpainText from '../FivSpainText'

export default function FivSpain()  {
  return (
    <>
{/* <ShortHeader /> */}

<SpainHeaderComp logoSrc="/images/logotipo_blanco.svg"/>
 <Section
        style={{
          background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '50px ',
          minHeight: '150px', // Add this line to ensure minimum height
        }}
/>
 {/* <AssistedReproductionSection />  */}
<FivSpainText />
 

    {/* <div className='spain_text' >
        <div className='cs_banner cs_bg_filed spain_text_content margin_legalt'>
        <h1 className='spain_text_title'>AVISO IMPORTANTE</h1>
        <p>En cumplimiento de la Ley Orgánica 1/2023, de 28 de febrero, por la que se modifica la Ley Orgánica 2/2010, de 3 de marzo, de salud sexual y reproductiva y de la interrupción voluntaria del embarazo, Gestlife no puede hacer publicidad en España de la gestación subrogada por lo que lamentamos no poder informarle desde España.</p>

        <p><b>Artículo 32. Prevención de la gestación por subrogación o sustitución. </b>La gestación por subrogación o sustitución es el contrato por el que se acuerda la gestación, con o sin precio, a cargo de una mujer que renuncia a la filiación materna a favor del contratante o de un tercero.   </p>
        <p>
        <b>Se promoverá la información, a través de campañas institucionales, de la ilegalidad de estas conductas,</b>así como la nulidad de pleno derecho del contrato por el que se convenga la gestación, con o sin precio, a cargo de una mujer que renuncia a la filiación materna a favor del contratante o de un tercero.
        </p>
        <p><b>Artículo 33. Prohibición de la promoción comercial de la gestación por sustitución.</b> En coherencia con lo establecido en el párrafo cuarto del artículo 3.a) de la Ley 34/1988, de 11 de noviembre, General de Publicidad, las Administraciones Públicas instarán la acción judicial dirigida a la declaración de ilicitud de la publicidad que promueva las prácticas comerciales para la gestación por sustitución y a su cese.»</p>
        </div>
    </div> */}
    </>
  )
}
